import styled from 'styled-components';
/**
 * This component is a wrapper for the input, description, error message and label
 */
export const InputControl = styled.div ``;
//# sourceMappingURL=input-control.js.map